import React from 'react';
import './kovin.css';

const DrVasumathy = () => {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          
        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">International</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/dr vasumathy.jpg" alt="Dr. Vasumathy Vedantham" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Dr. Vasumathy Vedantham</h3>
              <div className="name-underline"></div>
            </div>
          </div>

          <div className="bio-container">
            <p className="bio">
Dr. Vasumathy Vedantham is the consultant vitreoretinal surgeon and one of the medical directors of Radhatri Nethralaya. She has the distinction of being the alumnus of premier institutions such as Madras Medical College (MMC) & RIO-GOH (Regional Institute of Ophthalmology), Chennai where she completed her M.B.B.S & M.S Ophthalmology, L.V Prasad Eye Institute (LVPEI), Hyderabad, where she did her vitreoretinal fellowship and Aravind Eye Hospital, Madurai where she worked as a retina consultant for five years and Moorfields Eye Hospital, London where she did her fellowship in pediatric retina, ROP and Electrophysiology of the Eye.
<br /><br />
She is a member of All India Ophthalmologic Society (AIOS), Tamil Nadu Ophthalmic Association (TNOA), Andhra Pradesh State Ophthalmic Society (APSOS) and Indian Women Ophthalmologists Society (IWOS). She is the National Task force member in the Indian ROP Research Group for the prevention of Childhood blindness due to Retinopathy of Prematurity (ROP) in preterm babies. She is a National task force member of Rashtriya Bala Swastiya Karyakram (RBSK) of the Govt of India for prevention of blindness due to Cortical Visual Impairment (CVI) in special children with cerebral palsy.
<br /><br />
She has a distinguished academic record with fifteen gold medals including the best outgoing medical student for M.B.B.S (Lady Grant Duff Gold Medal for best outgoing Medical Student, Dr. J.A.S. Masilamani Memorial Gold Medal for the highest marks in all University Exams) and M.S Ophthalmology (the 'Thiru C. K. Kumaraswamy 51st Birthday Commemoration Gold Medal' for the highest marks obtained in the university examinations). She is the recipient of the prestigious Rakesh Sharma memorial award conferred by All India Ophthalmologic Society (AIOS) for best work in ocular trauma in India in 2005 and 48 publications in peer reviewed national and international journals and several presentations in conferences and symposia. Her area of expertise involves endophthalmitis, electrophysiology, paediatric retinal disorders, especially Retinopathy of prematurity and ocular trauma. She has been conferred with the coveted Hanumantha Reddy Award for the best work done in pediatric ophthalmology in India. The award recognizes her exemplary work on eye infections in children. She is a member of Royal College of Surgeons, Edinburgh, UK, having topped the FRCS examination in 1999.

<br /><br />

She is actively involved in community work by conducting eye camps especially in schools, eye awareness programmes, etc.,. She is the founder and managing trustee of the public charitable trust, Gurupriya Vision Research Foundation, whose motto is to eliminate all causes of preventable blindness.
            </p>
            <div className="bio-decoration"></div>
          </div>
        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
          <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};


export default DrVasumathy